export default __webpack_public_path__ + "static/hero-4aa65365d3dfe95b4227812fe642402e.jpg";